const setUserInfoData = (payload = {}) => {
    return payload;
};

const userDuesDekorator = (response = {}) => {
    const { payload = {} } = response;
    return payload;
};

export { setUserInfoData, userDuesDekorator };
